var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterproof({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    preserveAspectRatio: "xMidYMid meet",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.202 14.571c.013 6.545.013 10.22 0 11.024m-4.667-.244a2.336 2.336 0 004.672 0M5 14.571h22.443c-1.434-6.37-5.174-9.554-11.223-9.554-6.046 0-9.786 3.185-11.22 9.554z",
    stroke: "currentColor",
    strokeWidth: 1.818,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.9,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterproof);
export default __webpack_public_path__ + "static/media/Waterproof.909f3b5d9e91be3655319878723bdf80.svg";
export { ForwardRef as ReactComponent };